module.exports = "/images/hot-sale.png?d21f09df4702e3331184dcddef58ae90";